<section class="container">
  <div
    *ngIf="pageHeader"
    class="row pb-md-4"
  >
    <div class="section col-lg-12">
      <ng-content select="[header-section]"></ng-content>
    </div>
  </div>
  <div class="row">
    <div class="section col-lg-2">
      <ng-content select="[left-section]"></ng-content>
    </div>
    <div
      *ngIf="selectedTemplateType !== templateTypes.twoColumns"
      class="section"
      [ngClass]="{
      'col-lg-7': selectedTemplateType === templateTypes.legacy,
      'col-lg-8': selectedTemplateType === templateTypes.equalSides
      }"
    >
      <ng-content select="[middle-section]"></ng-content>
    </div>
    <div
      class="section right-bar flex-grow-1"
      [ngClass]="{
      'col-lg-3': selectedTemplateType === templateTypes.legacy,
      'col-lg-2': selectedTemplateType === templateTypes.equalSides,
      'col-lg-10': selectedTemplateType === templateTypes.twoColumns
      }"
    >
      <ng-content select="[right-section]"></ng-content>
    </div>
  </div>
</section>
